import { IGraphType, IWidgetType, WidgetDimensionsType } from '@/js/services/api/widget/types';

type WidgetDimensions = Record<IGraphType | IWidgetType | 'Empty', WidgetDimensionsType>;

export const defaultWidgetDimensionConfig: WidgetDimensions = {
    Text: {
        minH: 4,
        maxH: 6,
        minW: 3,
        maxW: 6,
        h: 4,
        w: 6,
    },
    Prompt: {
        minH: 4,
        maxH: 6,
        minW: 3,
        maxW: 6,
        h: 4,
        w: 6,
    },
    Donut: {
        minH: 4,
        maxH: 6,
        h: 4,
        minW: 3,
        maxW: 4,
        w: 3,
    },
    Pie: {
        minH: 4,
        maxH: 6,
        h: 4,
        minW: 3,
        maxW: 4,
        w: 3,
    },
    Polar: {
        minH: 4,
        maxH: 6,
        h: 4,
        minW: 6,
        maxW: 12,
        w: 6,
    },
    Line: {
        minH: 4,
        maxH: 6,
        h: 4,
        minW: 6,
        maxW: 12,
        w: 6,
    },
    Graph: {
        minH: 4,
        maxH: 6,
        h: 4,
        minW: 3,
        maxW: 4,
        w: 3,
    },
    StaticGraph: { minH: 4, maxH: 6, h: 4, minW: 3, maxW: 4, w: 3 },
    TopList: {
        minH: 4,
        maxH: 6,
        h: 4,
        minW: 6,
        maxW: 12,
        w: 6,
    },
    Column: {
        minH: 4,
        maxH: 6,
        h: 4,
        minW: 6,
        maxW: 12,
        w: 6,
    },
    Empty: {
        minH: 4,
        maxH: 4,
        h: 4,
        minW: 6,
        maxW: 6,
        w: 6,
    },
};

export const defaultEmptyWidget = {
    x: 0,
    y: 0,
    type: 'Empty',
    id: 'Empty',
    ...defaultWidgetDimensionConfig.Empty,
};
